module.exports = __webpack_public_path__ + "static/media/Platform.0b086230.svg";